export default __webpack_public_path__ + "static/media/background-projects.332ef5a8.png";